(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[822],{

/***/ 1266:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[uid]",
      function () {
        return __webpack_require__(4440);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 8140:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RecentRelatedStories; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
;// CONCATENATED MODULE: ./components/RecentRelatedStories/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj, _obj1;
    return {
        featuredBlogs: (_obj1 = {
            backgroundImage: "url('/blueCirclePattern.png')",
            backgroundColor: "#4A92CF",
            backgroundPosition: "center",
            backgroundSize: "150% 100%",
            backgroundRepeat: "no-repeat",
            paddingTop: theme.spacing(10),
            paddingBottom: theme.spacing(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
        }, _defineProperty(_obj1, theme.breakpoints.down("sm"), {
            paddingTop: theme.spacing(9),
            paddingBottom: theme.spacing(9),
            backgroundSize: "cover"
        }), _defineProperty(_obj1, theme.breakpoints.down("xs"), {
            paddingTop: theme.spacing(8),
            paddingBottom: theme.spacing(8)
        }), _defineProperty(_obj1, "& .featureBlogsContainer", (_obj = {
            marginTop: theme.spacing(10),
            marginBottom: theme.spacing(10)
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            marginTop: theme.spacing(9),
            marginBottom: theme.spacing(9)
        }), _defineProperty(_obj, theme.breakpoints.down("xs"), {
            marginTop: theme.spacing(8),
            marginBottom: theme.spacing(8)
        }), _defineProperty(_obj, "& .speakerInfo", {
            backgroundColor: "#242440",
            marginTop: "-4px",
            "& .name, .title": {
                color: "#fff",
                textAlign: "left"
            }
        }), _obj)), _obj1)
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/PersonItem/index.js + 1 modules
var PersonItem = __webpack_require__(5568);
// EXTERNAL MODULE: ./components/TitleSubtitle/index.js + 1 modules
var TitleSubtitle = __webpack_require__(8785);
// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
;// CONCATENATED MODULE: ./components/RecentRelatedStories/index.js














var dateOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
};
var FeaturedBlogsInProjects = function(param) {
    var classes = param.classes, allBlogsBasedOnProjectCategory = param.allBlogsBasedOnProjectCategory;
    var layout = (0,layout_context/* useLayout */.$Y)().layout;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.featuredBlogs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            maxWidth: "lg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleSubtitle/* default */.Z, {
                    title: layout && prismic_reactjs.RichText.asText(layout.related_stories_section_title),
                    subtitle: layout && prismic_reactjs.RichText.asText(layout.related_stories_section_subtitle),
                    showClass: true
                }),
                allBlogsBasedOnProjectCategory && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    spacing: 4,
                    direction: "row",
                    justify: "center",
                    className: "featureBlogsContainer",
                    children: allBlogsBasedOnProjectCategory && allBlogsBasedOnProjectCategory.slice(0, 3).map(function(blog, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                            item: true,
                            xs: 12,
                            sm: 6,
                            md: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PersonItem/* default */.Z, {
                                link: blog,
                                showTag: blog.data.project_categories && blog.data.project_categories.length > 0,
                                tag: blog.data.blog_topics && blog.data.blog_topics.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                    link: blog.data.blog_topics[0].blog_topic,
                                    children: prismic_reactjs.RichText.asText(blog.data.blog_topics[0].blog_topic.data.topic_name)
                                }) : null,
                                bannerImageSrc: blog.data.featured_image.url,
                                bannerImageAlt: blog.data.featured_image.alt,
                                name: prismic_reactjs.RichText.asText(blog.data.title),
                                title: (0,prismic_reactjs.Date)(blog.data.date).toLocaleDateString((0,router.useRouter)().locale, dateOptions)
                            })
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    container: true,
                    direction: "row",
                    justify: "center",
                    alignItems: "center",
                    children: layout && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                        link: layout.related_stories_section_button_link,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            variant: "outlined",
                            children: prismic_reactjs.RichText.asText(layout.related_stories_section_button_text)
                        })
                    })
                })
            ]
        })
    });
};
FeaturedBlogsInProjects.propTypes = {
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var RecentRelatedStories = ((0,withStyles/* default */.Z)(style)(FeaturedBlogsInProjects));


/***/ }),

/***/ 4440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _uid_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-slicezone/index.js
var next_slicezone = __webpack_require__(8917);
// EXTERNAL MODULE: ./utils/additional-data-context.js
var additional_data_context = __webpack_require__(1623);
// EXTERNAL MODULE: ./utils/layout-context.tsx
var layout_context = __webpack_require__(5385);
// EXTERNAL MODULE: ./sm-resolver.js + 141 modules
var sm_resolver = __webpack_require__(7982);
// EXTERNAL MODULE: ./components/RecentRelatedStories/index.js + 1 modules
var RecentRelatedStories = __webpack_require__(8140);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/prismic-reactjs/dist/prismic-reactjs.js
var prismic_reactjs = __webpack_require__(5833);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(1749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(3832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(2318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 24 modules
var withStyles = __webpack_require__(9438);
;// CONCATENATED MODULE: ./components/HeroBackgroundImage/style.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var styles = function(theme) {
    var _obj;
    return {
        workDetailsHeroBackground: {
            backgroundPosition: "center",
            backgroundSize: "cover",
            "& .container ": {
                height: "100%"
            }
        },
        backgroundOverlay: (_obj = {
            backgroundColor: "rgba(0,0,0,0.2)",
            height: 826
        }, _defineProperty(_obj, theme.breakpoints.down("sm"), {
            padding: theme.spacing(20, 2),
            height: "100%"
        }), _defineProperty(_obj, "& .highlightedText,.description, .boldText, .projectCatTitle", {
            color: "#fff",
            textTransform: "uppercase",
            textAlign: "center",
            padding: theme.spacing(1.5, 0)
        }), _defineProperty(_obj, "& .projectCatTitle", {
            textDecoration: "underline",
            cursor: "pointer",
            textDecorationThickness: "2px"
        }), _defineProperty(_obj, "& .boldText", {
            fontWeight: 900
        }), _obj),
        heroButton: _defineProperty({
            display: "flex",
            marginTop: theme.spacing(4),
            "& button": {
                margin: theme.spacing(2)
            }
        }, theme.breakpoints.down("sm"), {
            justifyContent: "center",
            flexDirection: "column;",
            alignItems: "center"
        })
    };
};
/* harmony default export */ var style = (styles);

// EXTERNAL MODULE: ./components/CustomLink/index.js + 1 modules
var CustomLink = __webpack_require__(6833);
// EXTERNAL MODULE: ./components/VideoModal/index.js + 1 modules
var VideoModal = __webpack_require__(202);
// EXTERNAL MODULE: ./utils/prop-types.js
var utils_prop_types = __webpack_require__(9725);
;// CONCATENATED MODULE: ./components/HeroBackgroundImage/index.js













var HeroBackgroundImage = function(param) {
    var primary = param.primary, classes = param.classes;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var openVideoDialog = function() {
        setOpenModal(true);
    };
    var closeVideoDialog = function() {
        setOpenModal(false);
    };
    var styles = {};
    if (primary.data && primary.data.featured_image) {
        styles.backgroundImage = "url(".concat(primary.data.featured_image.url, ")");
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.workDetailsHeroBackground,
        style: styles,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classes.backgroundOverlay,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: "lg",
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        direction: "column",
                        justify: "center",
                        alignItems: "center",
                        className: "container",
                        children: [
                            primary.data.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h3",
                                component: "h1",
                                className: "description",
                                children: prismic_reactjs.RichText.asText(primary.data.title)
                            }),
                            primary.data.project_category.data && primary.data.project_category.data.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                link: primary.data.project_category,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "subtitel1",
                                    className: "projectCatTitle boldText",
                                    children: prismic_reactjs.RichText.asText(primary.data.project_category.data.title)
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.heroButton,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        link: primary.data.cta1_button_link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            color: "primary",
                                            children: prismic_reactjs.RichText.asText(primary.data.cta1_button_text)
                                        })
                                    }),
                                    primary.data.secondary_button_type ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        onClick: openVideoDialog,
                                        variant: "outlined",
                                        children: prismic_reactjs.RichText.asText(primary.data.cta2_button_text)
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomLink/* default */.Z, {
                                        link: primary.data.cta2_button_link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "outlined",
                                            children: prismic_reactjs.RichText.asText(primary.data.cta2_button_text)
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                    open: openModal,
                    handleClose: closeVideoDialog,
                    video: primary.data.vimeo_link
                })
            ]
        })
    });
};
HeroBackgroundImage.propTypes = {
    slice: prop_types_default().shape({
        primary: prop_types_default().shape({
            title: utils_prop_types/* structuredTextPropTypes */.h,
            description: utils_prop_types/* structuredTextPropTypes */.h,
            backgroundImage: utils_prop_types/* imagePropTypes */.R,
            primaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h,
            secondaryCtaButtonText: utils_prop_types/* structuredTextPropTypes */.h
        }).isRequired,
        items: (prop_types_default()).array.isRequired
    }).isRequired,
    classes: prop_types_default().objectOf((prop_types_default()).any).isRequired
};
/* harmony default export */ var components_HeroBackgroundImage = ((0,withStyles/* default */.Z)(style)(HeroBackgroundImage));

// EXTERNAL MODULE: ./components/Head/index.js
var Head = __webpack_require__(4394);
;// CONCATENATED MODULE: ./pages/project/[uid].js
function _uid_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _uid_defineProperty(target, key, source[key]);
        });
    }
    return target;
}









var Project = function(props) {
    var data = props.data, currentProject = props.currentProject, uid = props.uid;
    var setHeaderColor = (0,layout_context/* useLayout */.$Y)().setHeaderColor;
    (0,react.useEffect)(function() {
        if (data) setHeaderColor(false);
    }, [
        data
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* default */.Z, {
                data: data,
                canonical: "/project/".concat(uid)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(additional_data_context/* AdditionalDataProvider */.YZ, {
                value: props.additionalData,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_HeroBackgroundImage, {
                        primary: currentProject
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_slicezone/* default */.Z, _objectSpread({}, props, {
                        resolver: sm_resolver/* default */.Z
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentRelatedStories/* default */.Z, {
                        allBlogsBasedOnProjectCategory: props.allBlogsBasedOnProjectCategory
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _uid_ = (Project);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [112,430,100,931,675,226,416,774,888,179], function() { return __webpack_exec__(1266); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);